import { Box } from "@material-ui/core";
import { Switch, Route } from "react-router-dom";

import { LiveUnitNav } from "@/common/components/LiveUnitNav";
import { RequestedVideosPage } from "@/common/components/RequestedVideosPage/RequestedVideosPage";

import { ArchivesPage, cabinetArchivePage, liveUnitArchivePage } from "../archives/ArchivesPage";
import { StreamPage } from "../stream/StreamPage";
import useStyles from "./LiveUnitPage.styles";


export const LiveUnitPage: React.FC = () => {
    const classes = useStyles();

    return (
        <Box className={classes.root}>
            <LiveUnitNav />
            <Switch>
                <Route path={"/camera/:cameraId/stream"}>
                    <StreamPage />
                </Route>
                <Route
                    path={"/live-unit/:liveUnitId/history"}
                    render={(props) => (
                        <ArchivesPage pageType={liveUnitArchivePage(parseInt(props.match.params.liveUnitId, 10))} />
                    )}
                />
                <Route
                    path={"/live-unit/:liveUnitId/requested-video"}
                    render={(props) => <RequestedVideosPage liveUnitId={parseInt(props.match.params.liveUnitId, 10)} />}
                />
                <Route
                    path={"/archive-cabinet/:cabinetId/history"}
                    render={(props) => (
                        <ArchivesPage pageType={cabinetArchivePage(parseInt(props.match.params.cabinetId, 10))} />
                    )}
                />
            </Switch>
        </Box>
    );
};
